import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-ib" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createCommentVNode(" 일반적인 상황 "),
        (!_ctx.isItem0502)
            ? (_openBlock(), _createBlock(_component_v_radio_group, {
                key: 0,
                class: "radio-group",
                modelValue: _ctx.isAuthorized,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.isAuthorized) = $event)),
                inline: "",
                density: "compact",
                "hide-details": ""
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_radio, {
                        label: _ctx.locale.use,
                        value: true
                    }, null, 8 /* PROPS */, ["label"]),
                    _createVNode(_component_v_radio, {
                        label: _ctx.locale.noUse,
                        value: false
                    }, null, 8 /* PROPS */, ["label"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createCommentVNode(" 0502 사용자 권한 관련 상황 "),
                _createVNode(_component_v_radio_group, {
                    class: "radio-group",
                    modelValue: _ctx.isAuthorized,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.isAuthorized) = $event)),
                    inline: "",
                    density: "compact",
                    "hide-details": ""
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_radio, {
                            "data-cy": "user-permission-setting-0502-radio",
                            label: _ctx.locale.use,
                            value: true,
                            disabled: !_ctx.getterIsChange0502PermissionAvailable
                        }, null, 8 /* PROPS */, ["label", "disabled"]),
                        _createVNode(_component_v_radio, {
                            label: _ctx.locale.noUse,
                            value: false,
                            disabled: !_ctx.getterIsChange0502PermissionAvailable
                        }, null, 8 /* PROPS */, ["label", "disabled"])
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
    ]));
}
